import { Outlet } from "react-router-dom";
import { redirectToSSOPortal } from "../utils/sso";

const PrivateRoute = () => {
  const token = localStorage.getItem("sso_token");

  if (!token) {
    redirectToSSOPortal();
    return null; // Render nothing while redirecting
  }

  return <Outlet />;
};

export default PrivateRoute;
